export default {
    'footer.link.termsOfService': 'Terms of Service',
    'footer.link.privacyPolicy': 'Privacy Policy',
    'footer.link.support': 'Support',
    'footer.link.contacts': 'Contacts',
    'footer.copyright': '© 2021 HABBY PTE. LTD. All Rights Reserved.'
};
